import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { MapPin, ArrowLeft } from "lucide-react";

export default function SchoolDetail() {
  const { slug } = useParams();
  const [listing, setListing] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setListing(null);
    setNotFound(false);
    api
      .get(`/listings/${slug}`)
      .then((res) => setListing(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="school-not-found">
        <h1 className="font-serif text-3xl text-slate-900">Listing not found</h1>
        <Link to="/" className="mt-4 inline-flex items-center gap-2 text-[#800020]">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
      </div>
    );
  }

  if (!listing) return <div className="py-24 text-center text-slate-500">Loading…</div>;

  return (
    <div data-testid="school-detail-page" className="bg-[#faf9f6]">
      {/* Header */}
      <div className="max-w-3xl mx-auto px-6 pt-8 pb-2 text-center" data-testid="school-header">
        <h1 className="font-serif text-3xl lg:text-4xl font-bold text-slate-900">{listing.school_name}</h1>
        <p className="mt-2 inline-flex items-center gap-2 text-slate-500">
          <MapPin className="h-4 w-4 text-[#800020]" /> {listing.location || listing.country}
        </p>
      </div>

      {/* Listing image followed by text (shown full, not cropped) */}
      <article className="max-w-5xl mx-auto px-6 py-8">
        {listing.image_url && (
          <img
            src={fileUrl(listing.image_url)}
            alt={listing.school_name}
            className="w-full h-auto rounded-xl shadow-lg mx-auto block"
            style={{ maxWidth: `${Number(listing.image_width) || 100}%` }}
            data-testid="school-detail-image"
          />
        )}
        <div
          className="bsd-prose mt-8 bg-white rounded-xl border border-slate-200 p-6 lg:p-10"
          data-testid="school-detail-content"
          dangerouslySetInnerHTML={{ __html: listing.content || "<p>No content available.</p>" }}
        />
      </article>
    </div>
  );
}
